import _ from 'lodash'

import fieldHelpers from '../../../ui-formly/fieldHelpers'
import partServer from '../../server'
import partQuantitiesField from './partQuantities/formly'

import { vsName as ServerUtilityName } from '../../../records/server/serverUtility'

formFields.$inject = ['userProfile']
function formFields(userProfile) {
  const fields = [
    fieldHelpers.columnLayout([
      {
        key: 'OnBehalfOfUserAuth',
        name: 'OnBehalfOfUserAuth',
        type: 'selectUser',
        templateOptions: {
          label: 'Person Checking in',
          disabled: !userProfile.hasPermission('onBehalfOf')
        },
        watcher: {
          listener: selectedUserChanged
        }
      }
    ], 3),
    fieldHelpers.columnLayout([
      {
        key: "PropertyId",
        name: "PropertyId",
        type: "selectAsync",
        templateOptions: {
          label: "Property",
          required: true,
          showAddButton: false,
          query: [ServerUtilityName, function (serverUtility) {
            return function (search){
              return serverUtility.lookupQuery({
                url: "/api/properties",
                search
              })
            }
          }],
          updateNameProp: 'PropertyName'
        },
        controller: ['$scope', ServerUtilityName, function ($scope, serverUtility) {
          serverUtility.fetchAll({
            url: "/api/properties",
            query: { OrderBy: "Name" }
          }).then(properties => {
            $scope.properties = properties
            const model = $scope.model
            const partProperty = model.PartProperty
            const { updateNameProp } = $scope.to
            let property

            if (partProperty) {
              const currentPropertyId = partProperty.PropertyId
              property = properties.find(p => p.Id === currentPropertyId)
            } else if (properties.length === 1) {
              property = properties[0]
            }

            if (updateNameProp && property) {
              $scope.model[updateNameProp] = property.Name
              $scope.model.PropertyId = property.Id
            }
          })
        }],
        expressionProperties: {
          'templateOptions.disabled': 'properties.length === 1'
        }
      },
      {
        key: 'PartPropertyId',
        name: 'PartPropertyId',
        type: 'selectAsync',
        templateOptions: {
          required: true,
          label: 'Room',
          query: [partServer.vsName, '$scope', '$q', function (partServer, $scope, $q) {
            return function (search) {
              let propertyId = $scope.model.PropertyId

              if (!propertyId) {
                return $q.when([])
              }

              return partServer.partPropertyQuery({
                NameContains: search,
                PropertyId: propertyId,
                Skip: 0,
                Take: 25,
                OrderBy: 'Name'
              })
            }
          }],
          showAddButton: false,
          getDefaultItem: function (model) {
            if (!model.PartProperty) {
              return {}
            }
            return model.PartProperty
          }
        },
        watcher: [{
          expression: 'model.PropertyId',
          listener: (field, newValue, oldValue, scope) => {
            if (oldValue !== newValue) {
              const partProperty = scope.model.PartProperty
              if (!(partProperty && partProperty.PropertyId === newValue)) {
                scope.model[field.key] = undefined
              }
            }
          }
        }],
        expressionProperties: {
          'templateOptions.disabled': '!model.PropertyId'
        }
      }
    ], 3),
    partQuantitiesField
  ]

  return _.flatten(fields)
}

function selectedUserChanged(field, newValue, oldValue, scope) {
  const oldUserAuthId = _.get(oldValue, 'UserAuthId')
  const newUserAuthId = _.get(newValue, 'UserAuthId')

  if (oldUserAuthId !== newUserAuthId) {
    scope.model.Parts = []
  }

}

export default formFields